module.exports = __webpack_public_path__ + "static/media/bg-1.9168cf83.jpg";